import { Formik } from "formik";
import React from "react";
import * as Yup from "yup";
import CustomInput from "../CustomInput";
import { Button } from "../ui/button";
import { useMutation, useQuery, useQueryClient } from "@tanstack/react-query";
import { addStaff, getRoles } from "src/api/settings";
import { showSuccessToast } from "src/lib/utils";
import { usePortalContext } from "src/context/PortalContext";
import CustomSelect from "../CustomSelect";
import { useDashboardContext } from "src/context/DashboardContext";

const initialValues = {
	first_name: "",
	last_name: "",
	email: "",
	phone: "",
	role_id: "",
	store_or_warehouse_id: "",
};

const validationSchema = Yup.object().shape({
	first_name: Yup.string().required("This field is required"),
	last_name: Yup.string().required("This field is required"),
	email: Yup.string().required("This field is required"),
	phone: Yup.string().required("This field is required"),
	role_id: Yup.string().required("This field is required"),
	store_or_warehouse_id: Yup.string().required("This field is required"),
});

const AddStaff = () => {
	const queryClient = useQueryClient();
	const closePortal = usePortalContext();
	const { entities } = useDashboardContext();

	const { mutate, isLoading } = useMutation(addStaff, {
		onSuccess: ({ message }) => {
			showSuccessToast(message);
			queryClient.invalidateQueries(["teams"]);
			closePortal();
		},
	});
	const { data: rawRoles } = useQuery({
		queryKey: ["roles"],
		queryFn: () => getRoles(),
		suspense: true,
	});
	const roles = rawRoles?.data ?? [];

	const entityOptions = entities?.map(({ id, name }) => ({ label: name, value: String(id) }));
	const roleOptions = roles?.map(({ id, name }) => ({ label: name, value: String(id) }));

	return (
		<Formik initialValues={initialValues} validationSchema={validationSchema} onSubmit={(values) => mutate(values)}>
			{({ values, handleChange, handleSubmit, setFieldValue }) => (
				<form onSubmit={handleSubmit} className="tw-grid tw-gap-4">
					<CustomInput
						label="First Name"
						name="first_name"
						type="text"
						placeholder="First Name"
						value={values.first_name}
						onChange={handleChange}
					/>
					<CustomInput
						label="Last Name"
						name="last_name"
						type="text"
						placeholder="Last Name"
						value={values.last_name}
						onChange={handleChange}
					/>
					<CustomInput label="Email" name="email" type="text" placeholder="Email" value={values.email} onChange={handleChange} />
					<CustomInput
						label="Phone Number"
						name="phone"
						type="text"
						placeholder="Phone Number"
						value={values.phone}
						onChange={handleChange}
					/>
					<CustomSelect
						name="role_id"
						label="Select Role"
						placeholder="Select Role"
						value={values.role_id}
						onChange={(value) => setFieldValue("role_id", value)}
						options={roleOptions}
					/>
					<CustomSelect
						name="store_or_warehouse_id"
						label="Select Warehouse/Storefront"
						placeholder="Select Warehouse/Storefront"
						value={values.store_or_warehouse_id}
						onChange={(value) => setFieldValue("store_or_warehouse_id", value)}
						options={entityOptions}
					/>
					<Button disabled={isLoading} className="mt-2">
						Add team member
					</Button>
				</form>
			)}
		</Formik>
	);
};

export default AddStaff;
